import React, { useEffect } from 'react';
import { useModal } from '@panel/commons/hooks';
import { site } from '@panel/commons/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { userInfo, fetchUserCore, seekerGuard, convertPublisher, setTaxConditions } from '../../ducks/seeker';
import { Modal } from '../Modals';
import { SeekerErrorModal } from './seekerErrorModal';
import { SeekerModal } from './seekerFormModal';
import { getTaxConditions } from '../../utils/identificationTypes';

const siteId = site.id;

function SeekerGuard() {
  const { isSeeker, email } = useSelector(userInfo);
  const { taxConditions, error, loading, converted, convertionError, mobilePhone } = useSelector(seekerGuard);
  const { isShowing: showError, toggleValue: toggleError } = useModal();
  const { isShowing: showForm, toggleValue: toggleForm } = useModal();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSeeker && taxConditions.length === 0) {
      dispatch(setTaxConditions(getTaxConditions(siteId)));
      toggleForm(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isSeeker, taxConditions]);

  useEffect(() => {
    if (isSeeker && !loading && error !== null && convertionError === null) {
      toggleForm(false);
      toggleError(true);
    } else if (isSeeker && !loading && error === null && convertionError !== null) {
      const recuperableFields = ['firstName', 'lastName', 'taxId', 'taxCondition', 'phone'];
      toggleForm(recuperableFields.includes(convertionError.fieldError));
      toggleError(!recuperableFields.includes(convertionError.fieldError));
    } else if ((converted || !isSeeker) && !loading && error === null) {
      toggleForm(false);
    } else {
      toggleForm(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSeeker, error, loading, converted]);

  useEffect(() => {
    if (converted) {
      dispatch(fetchUserCore());
    }
  }, [converted, dispatch]);

  const onCloseToHome = () => {
    toggleError(false);
    window.location.href = window.location.origin;
  };

  const onSubmit = data => {
    dispatch(convertPublisher({ ...data, email }));
  };

  if (showError) {
    return (
      <Modal>
        <SeekerErrorModal onClose={onCloseToHome} />
      </Modal>
    );
  }
  if (showForm) {
    return (
      <Modal data-repa='modal-seekerConversion'>
        <SeekerModal
          onSubmit={onSubmit}
          loading={loading}
          taxConditions={taxConditions}
          convertionError={convertionError}
          onClose={onCloseToHome}
          mobilePhone={mobilePhone}
        />
      </Modal>
    );
  }

  return null;
}

export { SeekerGuard };
